import { Scene } from 'phaser';
import { SCENES } from '../config/constants';

export class Boot extends Scene {
    constructor () {
        super(SCENES.BOOT);
    }

    create () {
        this.scene.start(SCENES.PRELOADER);
    }
}
